import { Button, Group, Select, Stack, Text } from '@mantine/core';
import { HiOutlineFilter } from 'react-icons/hi';
import ModalPopupComponent from 'components/ModalPopup';
import React, { useEffect, useState } from 'react';

interface ModalFilterCoursePlanProps {
  opened: boolean;
  defaultValue?: CoursePlanParams;
  onClose: () => void;
  onFilter: (_data: CoursePlanParams) => void;
}

export interface CoursePlanParams {
  programType: string | null;
  status: string | null;
}

const programTypeOptions = [
  { label: 'Program', value: 'Program' },
  { label: 'Modular', value: 'Modular' },
  { label: 'Emerging Needs', value: 'Emerging Needs' }
];

const ModalFilterCoursePlan: React.FC<ModalFilterCoursePlanProps> = ({
  defaultValue,
  onClose,
  onFilter,
  opened
}) => {
  const [selectedProgramType, setSelectedProgramType] = useState<string | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);

  useEffect(() => {
    if (defaultValue) {
      setSelectedProgramType(defaultValue.programType);
      setSelectedStatus(defaultValue.status);
    }
  }, [defaultValue]);

  const handleFilter = () => {
    onFilter({
      programType: selectedProgramType,
      status: selectedStatus
    });
    onClose();
  };

  const handleReset = () => {
    setSelectedProgramType(null);
    setSelectedStatus(null);
    onFilter({
      programType: null,
      status: null
    });
    onClose();
  };

  return (
    <ModalPopupComponent
      title={
        <Group gap={4}>
          <HiOutlineFilter size={20} />{' '}
          <Text fw={700} fz={20}>
            Filter
          </Text>
        </Group>
      }
      opened={opened}
      close={onClose}
    >
      <Stack>
        <Select
          label='Program Type'
          placeholder='Select Program Type'
          data={programTypeOptions}
          onChange={(value) => setSelectedProgramType(value)}
          value={selectedProgramType}
          clearable
        />
        <Group justify='space-between' mt={20}>
          <Button onClick={onClose} variant='outline'>
            Close
          </Button>
          <Group>
            <Button variant='transparent' onClick={handleReset}>
              Reset
            </Button>
            <Button onClick={handleFilter}>Filter</Button>
          </Group>
        </Group>
      </Stack>
    </ModalPopupComponent>
  );
};

export default ModalFilterCoursePlan;
